export const RefundType = Object.freeze({
	Any: 'Any',
	ERefund: 'E-refund',
	MailIn: 'Mail-in',
});

export default [
	{
		value: RefundType.Any,
		label: 'Any',
	},
	{
		value: RefundType.ERefund,
		label: 'E-refund',
	},
	{
		value: RefundType.MailIn,
		label: 'Mail-in',
	},
];
